import { UserDocument } from "@/models/schemas/User.schema";
import { ReactNode } from "react";

interface SidebarComponentDropdownProps {
  isTeamExpanded: boolean;
  setIsTeamExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  items: {
    title: string;
    onClick: () => void;
    image: ReactNode;
    shortcut?: string;
  }[];
  userInfo: Omit<UserDocument, "passwordHash"> | null;
}

const SidebarComponentDropdown: React.FC<SidebarComponentDropdownProps> = ({
  isTeamExpanded,
  setIsTeamExpanded,
  items,
  userInfo,
}) => {
  return (
    <>
      {isTeamExpanded && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="absolute p-2 top-[2rem] -left-4 w-56 bg-[var(--hoverBackground)] border border-neutral-700 rounded shadow-lg z-20 overflow-hidden animate-fadeIn"
        >
          {/* Header */}
          <div className="bg-blue-600 text-white text-sm text-left font-medium py-1 px-2 rounded">
            {userInfo ? `${userInfo.name}'s Team` : "Team Name"}
          </div>

          {/* Menu Items */}
          <ul className="py-1 text-sm">
            {items.map((item, index) => (
              <li key={index}>
                <div
                  role="button"
                  tabIndex={0}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsTeamExpanded(false);
                    item.onClick();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.stopPropagation();
                      setIsTeamExpanded(false);
                      item.onClick();
                    }
                  }}
                  className="cursor-pointer rounded w-full flex items-center justify-between px-4 py-2 text-[var(--primaryText)] hover:bg-[var(--foreground)] hover:text-[var(--hoverText)] transition"
                >
                  <div className="flex items-center gap-2 ">
                    <span className="text-lg">{item.image}</span>
                    {item.title}
                  </div>
                  <span className="text-xs ">
                    {item.shortcut ?? ""}
                  </span>
                </div>
              </li>
            ))}
          </ul>

          {/* Divider */}
          <div className="border-t border-neutral-700 "></div>

          {/* Footer Profile */}
          <div className="flex items-center gap-3 px-4 py-2 -mb-1.5">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#455a64] text-white font-medium">
              {userInfo ? userInfo.name.charAt(0).toUpperCase() : "T"}
            </div>
            <div className="flex flex-col">
              <span className="text-sm text-left text-[var(--primaryText)] font-medium">
                {userInfo ? userInfo.name : "User Name"}
              </span>
              <span className="text-xs text-[var(--secondaryText)]">
                {userInfo ? userInfo.email : ""}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SidebarComponentDropdown;
